module.exports = __webpack_public_path__ + "img/1.c818a2db.png";